import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import "./CountryInfo.css";
import Loader from "../loader/Loader";

const CountryInfo = () => {
  // get url params using useParams hook
  const { countryName, category } = useParams();

  const [country, setCountry] = useState({});
  const [loader, setLoader] = useState(false);

  /**
   * Accepts boolean value and set it to the state variable 'loader'
   * @param {boolean} status 
   */
  const toggleLoader = (status) => {
    setLoader(status);
  };

  /**
   * Get country by its name or alpha code
   */
  const getCountryByName = async () => {
    toggleLoader(true);
    try {
      let response = await axios.get(`/${category}/${countryName}`);

      category === "name"
        ? setCountry({ ...response.data[response.data.length - 1] })
        : setCountry(response.data);

      toggleLoader(false);
    } catch (e) {
      alert("Server not responding!");
      toggleLoader(false);
    }
  };

  /**
   * whenever countryName changes getCountryByName function will get called.
   */
  useEffect(() => {
    getCountryByName();
  }, [countryName]);

  return (
    <>
      {loader ? (
        <Loader />
      ) : (
        <div className="row country__info">
          <div className="col-lg-6">
            <img src={country.flag} alt={country.name + " flag"} />
          </div>
          <div className="col-lg-6">
            <h5 className="fw-bold my-3">{country.name}</h5>
            <div className="country__info__text">
              <div className="left">
                <p>
                  <strong>Native Name:</strong>
                  <span>{country.nativeName}</span>
                </p>
                <p>
                  <strong>Population:</strong>
                  <span>{country.population}</span>
                </p>
                <p>
                  <strong>Region:</strong>
                  <span>{country.region}</span>
                </p>
                <p>
                  <strong>Sub Region:</strong>
                  <span>{country.subregion}</span>
                </p>
                <p>
                  <strong>Capital:</strong>
                  <span>{country.capital}</span>
                </p>
              </div>

              <div className="right">
                <p>
                  <strong>Top level Domain:</strong>
                  {country.topLevelDomain &&
                    country.topLevelDomain.map((tld) => (
                      <span key={tld}>{tld}, </span>
                    ))}
                </p>
                <p>
                  <strong>Currencies:</strong>
                  {country.currencies &&
                    country.currencies.map((currency) => (
                      <span key={currency.name}>{currency.name}, </span>
                    ))}
                </p>
                <p>
                  <strong>Languages:</strong>
                  {country.languages &&
                    country.languages.map((lang) => (
                      <span key={lang.name}>{lang.name}, </span>
                    ))}
                </p>
              </div>
            </div>
            <div className="mt-5 d-flex">
              <strong className="me-3">Border Countries:</strong>
              <div className="country__border">
                {country.borders &&
                  country.borders.map((border) => (
                    <Link key={border} to={`/country-details/alpha/${border}`}>
                      {border}
                    </Link>
                  ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CountryInfo;
